import { render, staticRenderFns } from "./detailHandle.vue?vue&type=template&id=512bb11e&scoped=true&"
import script from "./detailHandle.vue?vue&type=script&lang=js&"
export * from "./detailHandle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512bb11e",
  null
  
)

export default component.exports